<template>
  <exo-table :root="_self">
    <exo-form :root="_self">
      <exo-input-name :root="_self" />
      <exo-input-string-array
        :root="_self"
        name="spaceObjectIdentifiers"
        :regExp="/\s*(?<id>[0-9]{5})/g"
        :delimiter="', '"
      />
      <v-data-table
        :headers="headerTableSatellitesInformations"
        :items="listSatellitesInformations"
        :height="350"
        style="width: 100%"
        dense
      ></v-data-table>
    </exo-form>
  </exo-table>
</template>

<script>
import axios from '../../services/axios'
import spaceObjectGroupUtils from '../../mixins/spaceObjectGroupUtils.js'
import defense from '../../mixins/defense.js'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import errorMixin from '../../mixins/logHandler.js'
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import dataTools from '../../tools/data.js'
Vue.use(VueAxios, axios)
import fieldsDescription from '../../tools/fieldsDescription.json'

export default {
  name: 'SpaceObjectGroup',

  mixins: [
    errorMixin,
    formMixin,
    numericalMixin,
    spaceObjectGroupUtils,
    defense
  ],
  components: {},

  data() {
    return {
      tableFields: [
        { value: 'displayedName', text: 'Name', sortable: true },
        { value: 'spaceObjectIdentifiers', text: 'List of space object ID' },
        { value: 'actions', text: 'Actions', sortable: false }
      ],
      inputs: {
        name: this.getDefaultValue('name'),
        id: this.getDefaultValue('id'),
        spaceObjectIdentifiers: []
      },
      listSatellitesInformations: [],
      headerTableSatellitesInformations: [],
      context: 'SpaceObjectCatalogueItem',
      updateTable: false
    }
  },
  watch: {
    'inputs.spaceObjectIdentifiers'(newValue) {
      if (newValue !== null) {
        this.updateListSatelliteFromCatalogue(newValue)
      }
    }
  },
  created() {},
  mounted() {
    this.getHeaderListSatelliteFromCatalogue()
  },
  methods: {
    getCurrentFormType() {
      return 'SpaceObjectGroup'
    },
    getCurrentFormTitle() {
      return 'Space object groups'
    },
    getSubTypes() {},

    getOptionalPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'optional'
      )
    },

    getRequiredPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'required'
      )
      return requiredList
    },
    getAllPropertiesUnionList() {
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'required'
      )
      let optionalList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'optional'
      )
      return [...new Set(requiredList.concat(optionalList))]
    },
    async updateListSatelliteFromCatalogue(spaceObjectIdentifiers) {
      this.listSatellitesInformations = []

      if (spaceObjectIdentifiers != null) {
        let listSatelliteInformationsBeforeConversion =
          await this.getDataSatellitesByNoradIdList(spaceObjectIdentifiers)
        this.listSatellitesInformations =
          listSatelliteInformationsBeforeConversion.map(
            (satelliteInformations) => {
              for (const property in satelliteInformations) {
                if (
                  satelliteInformations[property] === '' ||
                  satelliteInformations[property] === 'NaN'
                ) {
                  satelliteInformations[property] = 'N/A'
                } else {
                  satelliteInformations[property] =
                    this.getDisplayValueFromPathFieldDescription(
                      satelliteInformations[property],
                      [property],
                      this.context
                    )
                }
              }
              return satelliteInformations
            }
          )
      }
    },
    async getHeaderListSatelliteFromCatalogue() {
      this.headerTableSatellitesInformations = this.getHeadertableCatalogue(
        await this.getDataSatelliteByNoradId('37150')
      ) //i took a satellite with all the information to get the header
    },
    getHeadertableCatalogue(satelliteInformations) {
      return Object.keys(satelliteInformations).map((cle) => {
        return {
          text: this.getLabelWithUnitFromPathFieldDescription(
            [cle],
            this.context
          ),
          value: cle
        }
      })
    },
    clearForm() {
      this.inputs.name = this.getDefaultValue('name')
      this.inputs.spaceObjectIdentifiers = ['']
    },
    getCustomFields() {
      return ['spaceObjectIdentifiers']
    },
    displayCustomValue(item, header) {
      if (header === 'spaceObjectIdentifiers') {
        return item.spaceObjectIdentifiers.join(', ')
      }
    },
    getCustomInfos() {},
    getValueFields() {
      return []
    }
  }
}
</script>

<style scoped></style>
